import * as Sentry from '@sentry/browser';
import _ from 'lodash';

const logger = {
    error(err, additionalData) {
        console.error(err, additionalData);
        Sentry.withScope(function(scope) {
            scope.setExtra('Additional data', JSON.stringify(additionalData));
            Sentry.captureException(err);
        });
    },

    exception(message, errorMessage, additionalData) {
        const wrappedError = new Error(`${message}${_.isEmpty(errorMessage) ? '': ':'} ${errorMessage}`);
        console.error(wrappedError, additionalData);
        Sentry.withScope(function(scope) {
            scope.setExtra('Additional data', JSON.stringify(additionalData));
            Sentry.captureException(wrappedError);
        });
    },
};

export default logger;
